export function useNavBadges(): Record<string, number> {
  return {};
}
